/* 特价车
const routerConfig = {
  baseUrl: '/410/2020/specialcar/',
  router: [
    {
      path: '/cloudcars',
      name: 'CloudCars',
      component: resolve => require(['@/pages/BMW-Topic/Index.vue'], resolve),
    }
  ]
}
// */


/* 宝马专题*/
// const routerConfig = {
//   baseUrl: '/topic/seecargroup/baoma/',
//   router: [
//     {
//       path: '/bmwtopic',
//       name: 'BMWTopic',
//       component: resolve => require(['@/pages/BMW-Topic/Index.vue'], resolve),
//     }
//   ]
// }
//


/* 818预热
const routerConfig = {
 baseUrl: '/618/2020/specialcar/',
 router: [
   {
     path: '/warmup818',
     name: 'WarmUp818',
     component: resolve => require(['@/pages/warmup818/index'], resolve),
   },
   {
     path: '/policy',
     name: 'Policy',
     component: resolve => require(['@/pages/warmup818/policy'], resolve),
   }
 ]
}

/* 818 正式专题
const routerConfig = {
  // baseUrl: '/topic/',
  baseUrl: '/TopicApp/2020/818/',
  router: [
    {
      path: '/818Topic',
      name: '818Topic',
      component: resolve => require(['@/pages/2020818topico/index'], resolve),
    }
  ]
}

// /* 特价车长期活动落地页
const routerConfig = {
  // baseUrl: '/topic/',
  baseUrl: '/TopicApp/2020/0826/',
  router: [
    {
      path: '/SpecialCar',
      name: 'SpecialCar',
      component: resolve => require(['@/pages/SpecialCar0826/index'], resolve),
    },
    {
      path: '/rules',
      name: 'rules',
      component: resolve => require(['@/pages/SpecialCar0826/rules'], resolve),
    }
  ]
}

// /* 一元小订专题页
const routerConfig = {
  // baseUrl: '/topic/',
  baseUrl: '/TopicApp/2020/0825/',
  router: [
    {
      path: '/OneYuan',
      name: 'OneYuan',
      component: resolve => require(['@/pages/OneYuan0825/index'], resolve),
    }
  ]
}


//* 邀卖车活动页
const routerConfig = {
  baseUrl: '/TopicApp/2020/invitation/',
  router: [
    {
      path: '/shareindex',
      name: 'ShareIndex',
      component: resolve => require(['@/pages/InvitationSaleCar/ShareIndex'], resolve),
    },
    {
      path: '/salecar',
      name: 'SaleCar',
      component: resolve => require(['@/pages/InvitationSaleCar/SaleCar'], resolve),
    },
    {
      path: '/success',
      name: 'Success',
      component: resolve => require(['@/pages/InvitationSaleCar/Success'], resolve),
    }
  ]
}
//*/
//* 车商圈专题
const routerConfig = {
  baseUrl: '/TopicApp/2020/businessdistrict/',
  router: [
    {
      path: '/BusinessDistrict',
      name: 'BusinessDistrict',
      component: resolve => require(['@/pages/BusinessDistrict/index'], resolve),
    },
    {
      path: '/pc',
      name: 'pc',
      component: resolve => require(['@/pages/BusinessDistrict/pc'], resolve),
    }
  ]
}
//路由和baseURL 配置

export default routerConfig;


// WEBPACK FOOTER //
// ./src/router/routerConfig.js